import { observer } from "mobx-react";
import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { BetSlipStatusAbrv } from "@utils";

export default observer(function Payout() {
	const { t } = useTranslation("mybets");
	const bet = useContext(MyBetsBetContext);

	if (!bet.payout || bet.betSlipStatus.abrv === BetSlipStatusAbrv.LOST) {
		return null;
	}

	return (
		<tr className="table--bets__tr">
			<td className="table--bets__dd">
				{t<string>("ITEM.INFO_PAYOUT_LABEL")}
			</td>

			<td className="table--bets__dd u-color--offer--win">
				{bet.displayPayout}{" "}
			</td>
		</tr>
	);
});
